localStorage.setItem('countPerSecond', '0');
var access_token: string;
const pe_batching_url_local = "https://fa-officeaddin-dev.azurewebsites.net/api/PrivateEquityBatching?code=ioZM3_wzrwn_X8-JDMRIDw2M-yE2fQ__rJ1TIsFfogQtAzFuVZiOhQ==";
const pe_batching_url_stg = "https://fa-officeaddin-dev.azurewebsites.net/api/PrivateEquityBatching?code=ioZM3_wzrwn_X8-JDMRIDw2M-yE2fQ__rJ1TIsFfogQtAzFuVZiOhQ==";
const pe_batching_url_uat = "https://fa-officeaddin-uat.azurewebsites.net/api/PrivateEquityBatching?code=pgoLq7N8UCxHIsxUJHmCfizQq8hJjhHCuUJhGgm4_Lp7AzFuIxetdQ==";
const pe_batching_url_prod = "https://fa-officeaddin.azurewebsites.net/api/PrivateEquityBatching?code=G9AQixXIvjOoDF-0WInavVMSEE7ek8OOMWM5i1K1el8ZAzFuakFboA==";
const pe_batching_url = pe_batching_url_uat;

/**
 * Get Private Equity data.
 * @customfunction
 * @param measure measure string
 * @param currencyType currencyType any
 * @param fund fund string
 * @param fundGroup fundGroup any
 * @param company company any
 * @param transactionType transactionType any
 * @param investor investor any
 * @param glDate period(DD/MM/YYYY) any
 * @param effectiveDate effectiveDate any
 * @param glAccountCode glAccountCode string
 * @param glAccountName glAccountName string
 * @param fundPartnershipName fundPartnershipName any
 * @param investorGroup investorGroup any
 * @param periodLength periodLength any
 * @param investorType investorType any
 * @param investorAxiID investorAxiID any
 * @param investorGPCommitmentType investorGPCommitmentType any
 * @param investorGeography investorGeography any
 * @param investmentGeograpy investmentGeograpy any
 * @param periodQuarter periodQuarter any
 * @param effectiveQuarter effectiveQuarter any
 * @param specificInvestorID specificInvestorID any
 * @returns value.
 */
export async function PEUAT(measure: string, currencyType: any = null, fundGroup: any = null, fund: any = null, company: any = null, transactionType: any = null, investor: any = null, glDate: any = null, effectiveDate: any = null, glAccountCode: any = null, glAccountName: any = null, fundPartnershipName: any = null, investorGroup: any = null, periodLength: any = null, investorType: any = null, investorAxiID: any = null, investorGPCommitmentType: any = null, investorGeography: any = null, investmentGeograpy: any = null, periodQuarter: any = null, effectiveQuarter: any = null, specificInvestorID: any = null) {
  try {
    let generateAccessToken = false;
    if (access_token !== undefined && access_token !== null && access_token !== '') {
      let jwtPayload = JSON.parse(window.atob(access_token.split('.')[1]));
      if ((jwtPayload.exp * 10000) <= (new Date()).valueOf()) { generateAccessToken = true; }
    }
    if (access_token === undefined || access_token === null || access_token === '' || generateAccessToken) {
      access_token = await OfficeRuntime.auth.getAccessToken({
        allowSignInPrompt: true,
        allowConsentPrompt: true,
        forMSGraphAccess: true,
      });
    }
    return _pushOperation("PE", { measure, currencyType, fundGroup, fund, company, transactionType, investor, glDate, effectiveDate, glAccountCode, glAccountName, fundPartnershipName, investorGroup, periodLength, investorType, investorAxiID, investorGPCommitmentType, investorGeography, investmentGeograpy, periodQuarter, effectiveQuarter, specificInvestorID});
  } catch (error) { return error; }
}
let _batch = [];
let _isBatchedRequestScheduled = false;
// This function encloses your custom functions as individual entries,
// which have some additional properties so you can keep track of whether or not
// a request has been resolved or rejected.
function _pushOperation(op, args) {
  // Create an entry for your custom function.
  const invocationEntry = { operation: op, args: args, resolve: undefined, reject: undefined };

  // Create a unique promise for this invocation,
  // and save its resolve and reject functions into the invocation entry.
  const promise = new Promise((resolve, reject) => { invocationEntry.resolve = resolve; invocationEntry.reject = reject; });

  // Push the invocation entry into the next batch.
  _batch.push(invocationEntry);

  // If a remote request hasn't been scheduled yet,
  // schedule it after a certain timeout, e.g., 100 ms.
  if (!_isBatchedRequestScheduled) {
    _isBatchedRequestScheduled = true;
    setTimeout(_makeRemoteRequest, 100);
  }

  // Return the promise for this invocation.
  return promise;
}

// This is a private helper function, used only within your custom function add-in.
// You wouldn't call _makeRemoteRequest in Excel, for example.
// This function makes a request for remote processing of the whole batch,
// and matches the response batch to the request batch.
function _makeRemoteRequest() {
  // Copy the shared batch and allow the building of a new batch while you are waiting for a response.
  // Note the use of "splice" rather than "slice", which will modify the original _batch array
  // to empty it out.
  try {
    const batchCopy = _batch.splice(0, _batch.length);
    _isBatchedRequestScheduled = false;

    // Build a simpler request batch that only contains the arguments for each invocation.
    const requestBatch = batchCopy.map((item) => { return { operation: item.operation, args: item.args }; });
    let _chunkSize = batchCopy.length; //19000;
    splitArray(requestBatch, _chunkSize).forEach((chunk, index) => {
      // Make the remote request.
      _fetchFromRemoteService(chunk).then((responseBatch: any) => {
        if (responseBatch['token'] !== undefined) { localStorage.setItem('bcp_excel_platform_data_token', responseBatch['token']); }
        // Match each value from the response batch to its corresponding invocation entry from the request batch,
        // and resolve the invocation promise with its corresponding response value.
        responseBatch['data'].forEach((response) => {
          if (response.error) {
            batchCopy[(index * _chunkSize) + response["[index]"]].reject(new Error(response.error));
          } else {
            batchCopy[(index * _chunkSize) + response["[index]"]].resolve(response["[value]"]);
          }
        });
      });
    });
  } catch (error) { console.log(error); }
}

async function _fetchFromRemoteService(items) {
  return await fetch(pe_batching_url, {
    method: "POST",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('bcp_excel_platform_data_token'),
      'UserToken': ('Bearer ' + access_token)
    },
    body: JSON.stringify(items)
  }).then((response) => { return response.json(); });
}

function splitArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

  // try {
  //   // const access_token: string = "Test";
  //   // var pe_url = "https://fa-officeaddin-uat.azurewebsites.net/api/PrivateEquity?code=74a_CtvVcR13KRV7_ACdM1QfCGdPIyeWpbirXULM5hHbAzFuNHrWcQ==";

  //   localStorage.setItem('countPerSecond', (parseInt(localStorage.getItem('countPerSecond'), 10) + 1).toString());
  //   var response = await new Promise(async function (resolve, reject) {
  //     // await setTimeout(async () => {
  //     let generateAccessToken;
  //     if (access_token !== undefined && access_token !== null && access_token !== '') {
  //       let jwtPayload = JSON.parse(window.atob(access_token.split('.')[1]));
  //       if ((jwtPayload.exp * 1000) <= (new Date()).valueOf()) { generateAccessToken = true; }
  //     }
  //     if (access_token === undefined || access_token === null || access_token === '' || generateAccessToken) {
  //       access_token = await OfficeRuntime.auth.getAccessToken({
  //         allowSignInPrompt: true,
  //         allowConsentPrompt: true,
  //         forMSGraphAccess: true,
  //       });
  //     }
  //     fetch(pe_url, {
  //       method: "POST",
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': localStorage.getItem('bcp_excel_platform_data_token'),
  //         'UserToken': ('Bearer ' + access_token)
  //       },
  //       body: JSON.stringify({
  //         measure: measure,
  //         fund: fund,
  //         investor: investor,
  //         company: company,
  //         period: period,
  //         fundgroup: fundGroup,
  //         fundpartnershipname: fundPartnershipName,
  //         investorgroup: investorGroup,
  //         currencytype: currencyType,
  //         periodlength: periodLength,
  //         investortype: investorType,
  //         effectivedate: effectiveDate,
  //         investorgpcommitmenttype: investorGPCommitmentType,
  //         investorGeography: investorGeography,
  //         investmentGeograpy: investmentGeograpy,
  //         transactionType: transactionType,
  //         periodQuarter: periodQuarter
  //       })
  //     }).then((response) => {
  //       localStorage.setItem('countPerSecond', (parseInt(localStorage.getItem('countPerSecond'), 10) - 1).toString());
  //       return response.json();
  //     }).then((json) => {
  //       // console.log(json);
  //       if (json.message !== undefined && json.message.length > 0) {
  //         resolve(json['message']);
  //       } else {
  //         if (json['token'] !== undefined) {
  //           localStorage.setItem('bcp_excel_platform_data_token', json['token']);
  //         }
  //         resolve(json['value']);
  //       }
  //     }).catch((error) => {
  //       reject(error);
  //     });
  //     // }, 0);
  //     // }, parseInt(localStorage.getItem('countPerSecond'), 10) * 600);
  //     // }, (Math.floor(parseInt(localStorage.getItem('countPerSecond'), 10)/105)) * 1000*60);

  //     // countPerSecond = countPerSecond - 1;
  //   });
  //   return response;

  // } catch (error) {
  //   console.log(error, '------');
  //   return JSON.stringify(error);
  // }
// export async function getPEData(measure: string, fund: any = null, investor: any = null, company: any = null, period: any = null, fundgroup: any = null, fundpartnershipname: any = null, investorgroup: any = null, currencytype: any = null, periodlength: any = null, investortype: any = null, investoraxiid: any = null, effectivedate: any = null, investorgpcommitmenttype: any = null, iterationCount = 0) {
//   const _workspace_id = "139e7d29-ce4e-4d0b-b3fd-0e00e4f0cffb";
//   const _dataset_id = "64de53a4-a63e-4a9c-bfd9-d3903ca87c17";
//   const  _access_token: string = await OfficeRuntime.auth.getAccessToken({
//     allowSignInPrompt: true,
//     allowConsentPrompt: true,
//     forMSGraphAccess: true,
//   });

//   // const _access_token = localStorage.getItem('bcp_excel_platform_data_token');
//   // const _access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSJ9.eyJhdWQiOiI0MWUwMzk1MC1jOTI0LTQyYjYtOWYwNy04ODg1OTg4NDM5N2EiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vNzkzYzkzMzgtZGM0YS00MDVhLWJkOWMtOGU0NTdhYWJlNTQ5L3YyLjAiLCJpYXQiOjE2NjkxMDk4MzUsIm5iZiI6MTY2OTEwOTgzNSwiZXhwIjoxNjY5MTE0NDY5LCJhaW8iOiJBVlFBcS84VEFBQUFpQnRKZnJJVVBUeGNsaFJiUmV1azhmSU5DdzZsTGZha1ZDM1h2c1FjNEk5bG14Y0NwajZ0TzZWeFJtUE8vaHBBaHBmQWpSTEIvQi9KVHdLaU9oQnczRGs1UnNrTldoUXE2eERVamEyQnd5cz0iLCJhenAiOiJkMzU5MGVkNi01MmIzLTQxMDItYWVmZi1hYWQyMjkyYWIwMWMiLCJhenBhY3IiOiIwIiwibmFtZSI6IlBhbGxhLCBBc2hvayIsIm9pZCI6IjhiYzcwYTMxLTVmODgtNDg2MC1iODAzLTcxZmJlYmM3YTdhYSIsInByZWZlcnJlZF91c2VybmFtZSI6IkFzaG9rLlBhbGxhQGJjcGFydG5lcnMuY29tIiwicmgiOiIwLkFSOEFPSk04ZVVyY1drQzluSTVGZXF2bFNWQTU0RUVreWJaQ253ZUloWmlFT1hvZkFKcy4iLCJzY3AiOiJhY2Nlc3NfYXNfdXNlciIsInN1YiI6Im95SkllWWg5RGdVbUlHTlk1UERTWVp6VWF2SFJwSmRGaWdQaGhYQjlObDQiLCJ0aWQiOiI3OTNjOTMzOC1kYzRhLTQwNWEtYmQ5Yy04ZTQ1N2FhYmU1NDkiLCJ1dGkiOiJ1YXNzQ1RTSHprcVEyY0pWeXZlRUFBIiwidmVyIjoiMi4wIn0.sB1cnclTZTMLuMo5nZkXAQsugIa1GQtoS0IzdKWAVClKdKjd8YQN7id7wV--HMDqeWYBqpudwL8YQTTn5X6ODJYERxP8VSa970zOZIAVn-n0nj3PuVNq7yMNk9oXC07IQjGr7QzDcfWJ8i0l_HIDQbNL70U6GQd4a-0mwMvlnX883Z_G0iyjCrsan8ogrqu3M7zXlOEoRRekBlejYLbhJZQAKhGoF3ww6r1n1KiXqdMRBufamUBoGtF4mQ9SL2oUfJa5VCGFXkuShNArEhAfQP7xXel67ySXo16R33YsknLrgD9hlVmx7iR_8nX7s2ipxF47RXrg1sZvhgNkNOFGyw"
//   let _url = `https://api.powerbi.com/v1.0/myorg/datasets/${_dataset_id}/executeQueries`;

//   let query = "CALCULATE(["
//   query = query + measure + "]";
//   if (fund !== null && fund !== undefined && fund.toString().length > 0) {
//     query = query + `,KEEPFILTERS( 'fund'[fUNDNAME]="` + fund + `")`;
//   }
//   if (investor !== null && investor !== undefined && investor.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'investor'[iNVESTORNAME]="` + investor + `")`;
//   }
//   if (company !== null && company !== undefined && company.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'Portfolio company'[cOMPANYNAME]="` + company + `")`;
//   }
//   if (period !== null && period !== undefined && period.toString().length > 0) {
//     // let regix = /^([1-9]|0[1-9]|[12][0-9]|3[01])[/ /.]([1-9]|0[1-9]|1[012])[/ /.](19|20)\d\d$/gm;
//     // if (regix.test(period)) {
//     //   let periodArr = period.split('/');
//     //   var d = new Date(periodArr[2], parseInt(periodArr[1]) - 1, periodArr[0]);
//     //   if (d.getFullYear() == periodArr[2] && d.getMonth() == (parseInt(periodArr[1]) - 1) && d.getDate() == periodArr[0]) {
//     //     query = query + `,KEEPFILTERS( 'period'[pERIODDATE]={DATE(` + period[2] + ',' + (parseInt(period[1])) + ',' + period[0] + `)})`;
//     //   } else {
//     //     return 'Invalid Date Input';
//     //   }
//     // } else {
//     //   return 'Invalid Date format for period.';
//     // }


//     if(period.length >=8 && period.length <= 10) {
//       let periodArr = period.split('/');
//       if(periodArr.length === 3) {
//         let d = new Date(periodArr[2], parseInt(periodArr[1]) - 1, periodArr[0])
//         if (d.getFullYear() == periodArr[2] && d.getMonth() == (parseInt(periodArr[1]) - 1) && d.getDate() == periodArr[0]) {
//           query = query + `,KEEPFILTERS( 'period'[pERIODDATE]={DATE(` + periodArr[2] + ',' + periodArr[1] + ',' + periodArr[0] + `)})`;
//         } else {
//             return ("Invalid Date for period");
//         }
//       } else {
//         return ('Invalid date format for period(Expected DD/MM/YYY)');
//       }
//     } else {
//       return ('Invalid date format for period(Expected DD/MM/YYY)');
//     }

//     // if ((new Date(period)).toString() == "Invalid Date") {
//     //     // context.res = { status: 400, body: { message: 'Invalid Date format for period.' } }
//     //     return 'Invalid Date format for period.';
//     // }
//     // let d = new Date(period);
//     // query = query + `,KEEPFILTERS( 'period'[pERIODDATE]={DATE(` + d.getFullYear() + ',' + (d.getMonth() + 1) + ',' + d.getDate() + `)})`;
//   }
//   if (fundgroup !== null && fundgroup !== undefined && fundgroup.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'fund'[fUNDGROUP]="` + fundgroup + `")`;
//   }
//   if (fundpartnershipname !== null && fundpartnershipname !== undefined && fundpartnershipname.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'fund'[fUNDPARTNERSHIPNAME]="` + fundpartnershipname + `")`;
//   }
//   if (investorgroup !== null && investorgroup !== undefined && investorgroup.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'investor'[iNVESTORGROUP]="` + investorgroup + `")`;
//   }
//   if (currencytype !== null && currencytype !== undefined && currencytype.toString().length >= 0) {
//       query = query + `,KEEPFILTERS( 'source currency'[cURRENCYTYPE]="` + currencytype + `")`;
//   }
//   if (periodlength !== null && periodlength !== undefined && periodlength.toString().length >= 0) {
//       query = query + `,KEEPFILTERS( 'PortfolioFinancials'[pERIODLENGTH]="` + periodlength + `")`;
//   }
//   if (investortype !== null && investortype !== undefined && investortype.toString().length >= 0) {
//       query = query + `,KEEPFILTERS( 'investor'[iNVESTORTYPE]="` + investortype + `")`;
//   }
//   if (investoraxiid !== null && investoraxiid !== undefined && investoraxiid.toString().length >= 0) {
//       query = query + `,KEEPFILTERS( 'investor'[iNVESTORAXIID]="` + investoraxiid + `")`;
//   }
//   if (investorgpcommitmenttype !== null && investorgpcommitmenttype !== undefined && investorgpcommitmenttype.toString().length >= 0) {
//     query = query + `,KEEPFILTERS( 'investor'[iNVESTORGPCOMMITMENTTYPE]="` + investorgpcommitmenttype + `")`;
//   }
//   if (effectivedate !== null && effectivedate !== undefined && effectivedate.toString().length >= 0) {
//       query = query + `,KEEPFILTERS( 'GL Financials'[eFFECTIVEDATE]="` + effectivedate + `")`;
//   }
//   query = query + ')';
//   console.log(query);
//   return new Promise(function (resolve, reject) {
//     // let tokenUsedCount = localStorage.getItem('bcp_excel_platform_data_token_used_count') !== null ? parseInt(localStorage.getItem('bcp_excel_platform_data_token_used_count'), 10) : 0;
//     // tokenUsedCount = tokenUsedCount + 1;
//     // localStorage.setItem('bcp_excel_platform_data_token_used_count', tokenUsedCount.toString());
//     fetch(_url, {
//       method: "POST",
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${_access_token}`
//       },
//       body: JSON.stringify({
//         queries: [
//           {
//             "query": `EVALUATE ROW("Value",` + query + `)`
//           }
//         ],
//         serializerSettings: {
//           "includeNulls": true
//         }
//       })
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((json) => {
//         resolve(JSON.stringify(json["results"][0]["tables"][0]["rows"][0]["[Value]"]));
//       }).catch(async (error) => {
//         if (iterationCount === 0) {
//           localStorage.setItem('bcp_excel_platform_data_token', '');
//           // await generateToken();
//           iterationCount = iterationCount + 1;
//           resolve(getPEData(measure, fund, investor, company, period, fundgroup, fundpartnershipname, investorgroup, currencytype, periodlength, investortype, investoraxiid, effectivedate, investorgpcommitmenttype, iterationCount));
//         } else {
//           resolve('Please check later');
//         }
//       });
//   });
// }
CustomFunctions.associate("PEUAT", PEUAT);